import script from "./FacebookMetadata.vue?vue&type=script&lang=js"
export * from "./FacebookMetadata.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__